// Sales dashboard shown between the Home header and the status cards.
// The parent gates it on stores.performance. A range select and four channel
// pills drive every tile except Inventory watch; the choice is remembered per
// person in localStorage.

import { useEffect, useState } from 'react';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import {
  readStoredFilters,
  writeStoredFilters,
  type HomeFilters,
} from '@/lib/useHomeDashboard';
import { HammondsWholesale } from './HammondsWholesale';
import { HomeFilterBar } from './HomeFilterBar';
import { InventoryWatch } from './InventoryWatch';
import { SalesByHour } from './SalesByHour';
import { SalesVsLastYear } from './SalesVsLastYear';
import { StoreLeaderboard } from './StoreLeaderboard';
import { TopSellers } from './TopSellers';

export function SalesDashboard() {
  const [filters, setFilters] = useState<HomeFilters>(readStoredFilters);
  useEffect(() => {
    writeStoredFilters(filters);
  }, [filters]);

  return (
    <ErrorBoundary>
      <section aria-label="Sales dashboard" className="mb-8 flex flex-col" style={{ gap: 14 }}>
        <HomeFilterBar filters={filters} onChange={setFilters} />
        <SalesVsLastYear filters={filters} />
        <div className="grid grid-cols-1 lg:grid-cols-2" style={{ gap: 14 }}>
          <StoreLeaderboard filters={filters} />
          <TopSellers filters={filters} />
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2" style={{ gap: 14 }}>
          <SalesByHour filters={filters} />
          <HammondsWholesale filters={filters} />
        </div>
        <InventoryWatch />
      </section>
    </ErrorBoundary>
  );
}
